// All properties sorted alphabetically.
export enum SlugPrefix {
  category = 'category',
  chapter = 'ch',
  offer = 'offer',
  qaSet = 'question',
  subCategory = 'category',
}
